export default "__VITE_ASSET__DVFRXTOO__"